import { createThemeCompiler } from '../../../utils';

export const textareaThemeCompiler = createThemeCompiler(({ palette, stroke, borderRadius }) => ({
    textarea: {
        colors: {
            default: {
                backgroundColor: palette.white,
                borderColor: '#C8CED7',
                foregroundColor: palette.neutralPrimary
            },
            disabled: {
                backgroundColor: '#F8F9FA',
                borderColor: '#C5CAD2',
                foregroundColor: '#667287'
            },
            error: {
                backgroundColor: palette.redPale,
                borderColor: palette.red,
                foregroundColor: palette.neutralPrimary
            },
            focussed: {
                backgroundColor: palette.white,
                borderColor: palette.themePrimary,
                foregroundColor: palette.neutralPrimary
            },
            hovered: {
                backgroundColor: palette.white,
                borderColor: '#C8CED7',
                foregroundColor: palette.neutralPrimary
            }
        },
        composites: {
            borderStyle: 'solid',
            borderWidth: stroke.thin,
            borderRadius: borderRadius.curvedSmall
        }
    }
}));
